import type React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { AppSidebar } from '@/domains/shared/components/AppSidebar'
import { ErrorBoundary } from '@/domains/shared/components/ErrorBoundary'
import { SidebarInset, SidebarProvider } from '@/domains/shared/components/ui/Sidebar'
import { useAuthStore } from '@/store/useAuthStore'

/** The only route a user holding a temporary password may reach until they replace it. */
export const CHANGE_PASSWORD_PATH = '/change-password'

export const AuthenticatedLayout: React.FC = () => {
  const mustChangePassword = useAuthStore((s) => s.user?.mustChangePassword ?? false)

  if (mustChangePassword) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </SidebarInset>
    </SidebarProvider>
  )
}
